export default {
  en: {
    agent: 'Agent',
    pleaseSelectAgent: '-- Please select agent --',
    contactPerson: 'Contact Person',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedContactPersonMessage: 'This contact person has been updated',
    deletedContactPersonMessage: 'This contact person has been deleted'
  },
  th: {
    agent: 'ตัวแทน',
    pleaseSelectAgent: '-- กรุณาเลือกตัวแทน --',
    contactPerson: 'ผู้ติดต่อ',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedContactPersonMessage: 'ผู้ติดต่อนี้มีการแก้ไข',
    deletedContactPersonMessage: 'ผู้ติดต่อนี้ถูกลบไปแล้ว'
  }
}
